<div class="overview-panel" [ngClass]="{'overview-hidden': isOverviewActive}">
    <div class="overview-inner">
        <div class="d-flex justify-content-between align-items-center">
            <h4 class="fw-4">{{TAXONOMY_EXPLORER}}</h4>
            <div>
                <button mat-button (click)="refreshTaxonomyData()">Reload</button>
                <button mat-button (click)="close()">{{CLOSE}}</button>
            </div>
        </div>
        @if (isLoadingTaxonomy) {
            <div class="taxonomy-loading d-flex justify-content-center align-items-center">
                <mat-progress-spinner class="bright-spinner" mode="indeterminate"></mat-progress-spinner>
            </div>
        } @else if (schemaTree) {
            <schema-tree (result)="this.handler.onSelectFromTree($event)" [initData]="schemaTree"></schema-tree>
        }@else{
            <p>{{SELECT_DATA_SERVICE_FIRST}}</p>
        }
    </div>
</div>
